export default __webpack_public_path__ + "4a6099541af2a864b0d81213e053eed4.jpg";